import React, { Component } from "react";

import AdministrationTicket from "pages/administration/_components/tickets/AdministrationTicket";
import UserActionTicket from "./_components/tickets/UserActionTicket";

class UserActionTicketContent extends Component {
    render() {
        return (
            <AdministrationTicket {...this.props}>
                <UserActionTicket {...this.props} />
            </AdministrationTicket>
        );
    }
}

export default UserActionTicketContent;
